import { User } from "@/store/modules/AuthModule";

const ID_TOKEN_KEY = "id_token" as string;
const CURRENT_USER = "current_user" as string;

/**
 * @description get token form localStorage
 */
export const getToken = (): string | null => {
  return window.localStorage.getItem(ID_TOKEN_KEY);
};

/**
 * @description save token into localStorage
 * @param token: string
 */
export const saveToken = (token: string): void => {
  window.localStorage.setItem(ID_TOKEN_KEY, token);
};

/**
 * @description remove token form localStorage
 */
export const destroyToken = (): void => {
  window.localStorage.removeItem(ID_TOKEN_KEY);
};

/**
 * @description save user into localStorage
 * @param token: User
 */
export const saveCurrentUser = (user: User): void => {
  window.localStorage.setItem(CURRENT_USER, JSON.stringify(user));
};

/**
 * @description save user into localStorage
 * @param token: User
 */
export const destroyCurrentUser = (): void => {
  window.localStorage.removeItem(CURRENT_USER);
};

export const getCurrentUser = (): User | null => {
  return JSON.parse(localStorage.getItem(CURRENT_USER) || "null") as User;
};

export default {
  getToken,
  saveToken,
  destroyToken,
  getCurrentUser,
  saveCurrentUser,
  destroyCurrentUser,
};
